import { trpc } from '@/shared/api/trpc';

export const useFilterItinerariesData = (search: string, enabled: boolean) =>
  trpc.operations.filterItineraries.useQuery(
    { search, offset: 0, limit: 20 },
    { enabled: enabled && search.length >= 3, staleTime: 30_000 }
  );
